





































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
import {
  addEviBusinessbehavior,
  updateEviBusinessbehavior,
  deleteEviBusinessbehavior,
  getEviBusinessbehaviorPageList,
  defaultEviBusinessbehaviorData
} from "@/api/evibusinessbehavior";
import { getCurrectDictArr } from "@/api/evidict";
import { getEviSubjectArr } from "@/api/evisubject";
import { getEviBusinessArr } from "@/api/evibusiness";
import { IEviBusinessbehavior } from "@/model/evibusinessbehavior";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: "eviBusinessbehavior",
  components: {
    Pagination
  },
  filters: {
    // appTypeFilter: (key: number) => {
    // return appTypeDic.find((o: any) => o.key === key)?.value;
    // },
    // platformTypeFilter: (key: number) => {
    // return platformTypeDic.find((o: any) => o.key === key)?.value;
    // }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private eviBusinessbehaviorData = defaultEviBusinessbehaviorData;
  private list: IEviBusinessbehavior[] = [];
  private businessArr: any[] = [];
  private subjectArr: any[] = [];
  private dictTempArr: any[] = [];
  private total = 0;
  private listLoading = false;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: "",
    businessId: "",
    behaviorSubjectId: "",
    behaviorObjectSubject: ""
  };

  private dialogCreateVisible = false;
  private dialogDictVisible = false;

  private createRules = {
    businessId: [
      { required: true, message: "归属业务必填", trigger: "change" }
    ],

    behaviorName: [
      { required: true, message: "行为名称必填", trigger: "blur" }
    ],

    behaviorSubjectId: [
      { required: true, message: "行为主体必填", trigger: "change" }
    ],

    indexNo: [{ required: true, message: "序号必填", trigger: "blur" }],

    behaviorObjectSubject: [
      { required: true, message: "行为对象主体必填", trigger: "change" }
    ],

    behaviorAction: [
      { required: true, message: "行为动作必填", trigger: "blur" }
    ]

    // behaviorContent: [
    //   { required: true, message: "行为内容/凭证必填", trigger: "blur" }
    // ]

    // isActive: [{ required: true, message: "是否启用必填", trigger: "blur" }],

    // sort: [{ max: 10, message: "长度不能超过10位" }]
  };

  private handleDict(id: string) {
    this.getCurrectDictArr(id).then(() => {
      if (this.dictTempArr.length === 0) {
        this.$message({
          message: "请先配置行为模板数据字典!"
        });
      } else {
        this.dialogDictVisible = true;
      }
    });
  }

  private openCreateDialog() {
    this.initData();
    this.dialogCreateVisible = true;
  }

  private closeCreateDialog() {
    (this.$refs.createForm as Form).resetFields();
    this.dialogCreateVisible = false;
  }

  private handleFilter() {
    this.listQuery.pageIndex = 1;
    this.getList();
  }

  created() {
    this.getList().then(() => {
      this.getEviBusinessArr();
      this.getCurrentSubjectArr();
    });
  }

  private async getCurrectDictArr(pid: string) {
    const { data } = await getCurrectDictArr(pid, 2);

    this.dictTempArr = data;
  }

  private async getCurrentSubjectArr() {
    const { data } = await getEviSubjectArr();
    this.subjectArr = data;
  }

  private async getEviBusinessArr() {
    const { data } = await getEviBusinessArr();
    this.businessArr = data;
  }

  private handleUpdate(data: IEviBusinessbehavior) {
    this.dialogCreateVisible = true;
    // this.eviAppData = data;
    this.setData(data);
  }

  private initData() {
    this.eviBusinessbehaviorData.id = "";
    this.eviBusinessbehaviorData.businessId = "";
    this.eviBusinessbehaviorData.behaviorName = "";
    this.eviBusinessbehaviorData.behaviorSubjectId = "";
    this.eviBusinessbehaviorData.indexNo = 0;
    this.eviBusinessbehaviorData.createTime = null;
    this.eviBusinessbehaviorData.behaviorObjectSubject = "";
    this.eviBusinessbehaviorData.behaviorDate = null;
    this.eviBusinessbehaviorData.behaviorAction = "";
    this.eviBusinessbehaviorData.behaviorContent = "";
    this.eviBusinessbehaviorData.creatorId = "";
    this.eviBusinessbehaviorData.updateTime = null;
    this.eviBusinessbehaviorData.isActive = 0;
    this.eviBusinessbehaviorData.updateId = "";
    this.eviBusinessbehaviorData.sort = 0;
  }

  private setData(data: IEviBusinessbehavior) {
    this.eviBusinessbehaviorData.id = data.id;
    this.eviBusinessbehaviorData.businessId = data.businessId;
    this.eviBusinessbehaviorData.behaviorName = data.behaviorName;
    this.eviBusinessbehaviorData.behaviorSubjectId = data.behaviorSubjectId;
    this.eviBusinessbehaviorData.indexNo = data.indexNo;
    this.eviBusinessbehaviorData.createTime = data.createTime;
    this.eviBusinessbehaviorData.behaviorObjectSubject =
      data.behaviorObjectSubject;
    this.eviBusinessbehaviorData.behaviorDate = data.behaviorDate;
    this.eviBusinessbehaviorData.behaviorAction = data.behaviorAction;
    this.eviBusinessbehaviorData.behaviorContent = data.behaviorContent;
    this.eviBusinessbehaviorData.creatorId = data.creatorId;
    this.eviBusinessbehaviorData.updateTime = data.updateTime;
    this.eviBusinessbehaviorData.isActive = data.isActive;
    this.eviBusinessbehaviorData.updateId = data.updateId;
    this.eviBusinessbehaviorData.sort = data.sort;
  }

  private deleteEviBusinessbehavior(id: string) {
    this.$confirm("此操作将永久删除, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await deleteEviBusinessbehavior(id).then(() => {
          this.getList();

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
      });
    // .catch(() => {
    //   this.$message({
    //     type: "info",
    //     message: "已取消删除"
    //   });
    // });
  }

  private async update() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await updateEviBusinessbehavior(this.eviBusinessbehaviorData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogCreateVisible = false;
        this.getList();
      }
    });
  }

  private async create() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await addEviBusinessbehavior(this.eviBusinessbehaviorData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogCreateVisible = false;
          this.getList();
        });
      }
    });
  }

  // 获取列表数据
  private async getList() {
    this.listLoading = true;
    const { data } = await getEviBusinessbehaviorPageList(this.listQuery);
    this.list = data.list;
    this.total = data.total;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }
}
